import { render, staticRenderFns } from "./add-ad-group.vue?vue&type=template&id=858d0b74&scoped=true&"
import script from "./add-ad-group.vue?vue&type=script&lang=js&"
export * from "./add-ad-group.vue?vue&type=script&lang=js&"
import style0 from "./add-ad-group.vue?vue&type=style&index=0&id=858d0b74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858d0b74",
  null
  
)

export default component.exports